import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { unitMappings } from '@/hooks/useApi/utils/processUsageCostResponse'
import { useAnalyticsApi } from '@/hooks'
import {
    ComparisonCard,
    DashboardWidgetLoading,
    ErrorState,
} from '@/components'
import { useDashboardFiltersGetParams } from '@/stores/useDashboardUsageAndCostFiltersStore/useDashboardFiltersGetParams'

export const UsageComparisonCard: React.FC = () => {
    const { t } = useTranslation('translations')
    const { useInvoicesSummaryQuery } = useAnalyticsApi()

    const params = useDashboardFiltersGetParams()

    const { data, isError, isSuccess, isFetching } =
        useInvoicesSummaryQuery(params)

    if (isError) {
        return (
            <div className="grid min-h-[128px]">
                <ErrorState description={t('comparisonWidget.error')} />
            </div>
        )
    }

    if (isSuccess && !isFetching) {
        return (
            <ComparisonCard
                title={t('comparisonWidget.usageWidgetTitle')}
                currentSubtitle={t('comparisonWidget.currentSubtitle')}
                priorSubtitle={t('comparisonWidget.priorSubtitle')}
                currentValue={data.currentYear.usage.value}
                currentValueUnit={unitMappings[data.currentYear.usage.unit]}
                priorValue={data.lastYear.usage.value}
                priorValueUnit={unitMappings[data.lastYear.usage.unit]}
                currentFooterText={t('comparisonWidget.invoices', {
                    count: data.currentYear.count,
                })}
                priorFooterText={t('comparisonWidget.invoices', {
                    count: data.lastYear.count,
                })}
                currentDateRange={data.currentYear.dateRange}
                priorDateRange={data.lastYear.dateRange}
            />
        )
    }

    return (
        <div className="grid min-h-[128px]">
            <DashboardWidgetLoading />
        </div>
    )
}
